import React from "react";
import styles from "./Pagination.module.css";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

interface PaginationProps {
  total: number;
  current: number;
  onChange: (page: number) => void;
  pageSize?: number;
}

const Pagination: React.FC<PaginationProps> = ({
  total,
  current,
  onChange,
  pageSize = 10,
}) => {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;

  const getPages = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (current <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (current >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          current - 1,
          current,
          current + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const pages = getPages();

  return (
    <nav className={styles.pagination} aria-label="Pagination">
      <button
        className={styles.pageButton}
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        aria-label="Previous Page"
      >
        <FiChevronLeft size={20} />
      </button>
      {pages.map((page, idx) =>
        page === "..." ? (
          <span key={"ellipsis-" + idx} className={styles.ellipsis}>
            …
          </span>
        ) : (
          <button
            key={page}
            className={
              page === current
                ? `${styles.pageButton} ${styles.active}`
                : styles.pageButton
            }
            onClick={() => onChange(Number(page))}
            aria-current={page === current ? "page" : undefined}
          >
            {page}
          </button>
        )
      )}
      <button
        className={styles.pageButton}
        onClick={() => onChange(current + 1)}
        disabled={current === totalPages}
        aria-label="Next Page"
      >
        <FiChevronRight size={20} />
      </button>
    </nav>
  );
};

export default Pagination;
